import { NAME_SPACE as ns } from './constants';

export const SET_IS_PIPE_ENABLED = `${ns} SET_IS_PIPE_ENABLED`;
export const SET_IS_POWERLINE_ENABLED = `${ns} SET_IS_POWERLINE_ENABLED`;
export const SET_IS_CUSTOMER_DATA_ENABLED = `${ns} SET_IS_CUSTOMER_DATA_ENABLED`;
export const SET_IS_GROUPING_LAYER_ENABLED = `${ns} SET_IS_GROUPING_LAYER_ENABLED`;
export const SET_IS_GAP_LAYER_ENABLED = `${ns} SET_IS_GAP_LAYER_ENABLED`;
export const SET_IS_AVDATA_ENABLED = `${ns} SET_IS_AVDATA_ENABLED`;